import { loadPartialConfig } from '@babel/core';
import { configureStore } from '@reduxjs/toolkit';

import RootState from './interfaces/root.interface';

import cartSlice from './slices/cart.slice';
import orderSlice from './slices/order.slice';
import loadingSlice from './slices/loading.slice';
import favoriteSlice from './slices/favorites.slice';

const loadState = (): RootState | undefined => {
  try {
    const serializeState = localStorage.getItem('appState');
    if (serializeState) return <RootState>JSON.parse(serializeState);
  } catch (e) {
    console.warn(e);
  }

  return undefined;
};

const saveState = (state: RootState) => {
  try {
    localStorage.setItem('appState', JSON.stringify(state));
  } catch (e) {
    console.warn(e);
  }
};

const store = configureStore({
  reducer: {
    cart: cartSlice.reducer,
    currentOrder: orderSlice.reducer,
    loading: loadingSlice.reducer,
    favorites: favoriteSlice.reducer
  },
  preloadedState: loadState(),
});

store.subscribe(() => {
  saveState(store.getState());
});

export default store;
